import {isLastElement} from "@Array/isLastElement";
import React from "react";
import TicketType from "@MyTicket/types/Ticket.type";
import TicketIntermodalData from "@MyTicket/features/ticketDetails/components/TicketIntermodalData";
import {has24HoursPassed} from "@MyTicket/features/ticketDetails/functions/has24HoursPassed";
import TicketData from "@MyTicket/features/ticketDetails/components/TicketData";

interface TicketDataSectionProps {
    ticket: TicketType,
    isArchived: boolean,
}

function TicketDataSection({ticket, isArchived}: TicketDataSectionProps) {
    const {
        id,
        baseRoutes,
        singleRoute,
        returnRoute,
        status,
    } = ticket

    const {
        isCancelled,
        isExchangedForVoucher,
        isIntermodal,
        isReturn,
    } = status

    if (isIntermodal) {
        return (
            <>
                {baseRoutes.map((route, index) => {
                    const hasTransit = !isLastElement(baseRoutes, index)

                    return (
                        <TicketIntermodalData
                            key={`${id}-${route.id}`}
                            ticketId={`${id}`}
                            status={{
                                isCancelled,
                                isExchangedForVoucher,
                                isExpired: has24HoursPassed(route.departureStation.departureDateTime),
                                isMTicket: route.hasMTicket,
                            }}
                            currentRoute={route}
                            nextRoute={hasTransit && baseRoutes[index + 1]}
                            hasTransit={hasTransit}
                            routeType={route.transportTypeId}
                        />
                    )
                })}
            </>
        );
    }

    return (
        <>
            <TicketData
                id={`${id}`}
                status={{
                    isCancelled,
                    isExchangedForVoucher,
                    isExpired: has24HoursPassed(singleRoute.departureStation.departureDateTime),
                    isMTicket: singleRoute.hasMTicket,
                }}
                route={singleRoute}
                isArchived={isArchived}
                hasReturn={isReturn}
            />
            {isReturn && (
                <TicketData
                    id={`${id}`}
                    status={{
                        isCancelled,
                        isExchangedForVoucher,
                        isExpired: has24HoursPassed(returnRoute.departureStation.departureDateTime),
                        isMTicket: returnRoute.hasMTicket,
                    }}
                    hasReturn
                    isReturn
                    route={returnRoute}
                    isArchived={isArchived}
                />
            )}
        </>
    );
}

export default TicketDataSection;